import React, {ReactElement} from 'react';
import wrap from 'wraptile';

interface ContentItemViewPublishingRightsProps {
    tabs: string[];
    tabsPanel: ReactElement[];
}

export const mapTabs = wrap((tabsPanel: ReactElement[], tab: string, index: number) => (
    <div
        key={tab}
        className="publishing-rights-items__tabs-container"
    >
        <p>
            {tab.toUpperCase()}
        </p>
        {tabsPanel[index]}
    </div>

));

export const getTabs = (tabs: string[], tabsPanel: ReactElement[]) => {
    return tabs.map(mapTabs(tabsPanel));
};

export default function ContentItemViewPublishingRights(props: ContentItemViewPublishingRightsProps) {
    const {
        tabs,
        tabsPanel,
    } = props;
    
    return (
        <div className="publishing-rights-items">
            {getTabs(tabs, tabsPanel)}
        </div>
    );
}
